var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconITeams(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-i-teams") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3,6A2,2,0,1,0,1,4,2,2,0,0,0,3,6ZM17,6a2,2,0,1,0-2-2A2,2,0,0,0,17,6Zm1,1H16a2,2,0,0,0-1.41.58A4.57,4.57,0,0,1,16.94,11H19a1,1,0,0,0,1-1V9A2,2,0,0,0,18,7ZM10,7A3.5,3.5,0,1,0,6.5,3.5,3.5,3.5,0,0,0,10,7Zm2.4,1h-.26A4.83,4.83,0,0,1,7.86,8H7.6A3.6,3.6,0,0,0,4,11.6v.9A1.5,1.5,0,0,0,5.5,14h9A1.5,1.5,0,0,0,16,12.5v-.9A3.6,3.6,0,0,0,12.4,8Zm-7-.42A2,2,0,0,0,4,7H2A2,2,0,0,0,0,9v1a1,1,0,0,0,1,1H3.06A4.58,4.58,0,0,1,5.41,7.58Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconITeams);
export default __webpack_public_path__ + "static/media/icon-i-teams.bcad586796431bd375d26777e951e6f1.svg";
export { ForwardRef as ReactComponent };